import { render, staticRenderFns } from "./WeChatLoginConfirm.vue?vue&type=template&id=ce722684&scoped=true"
import script from "./WeChatLoginConfirm.vue?vue&type=script&lang=js"
export * from "./WeChatLoginConfirm.vue?vue&type=script&lang=js"
import style0 from "./WeChatLoginConfirm.vue?vue&type=style&index=0&id=ce722684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce722684",
  null
  
)

export default component.exports